import EntityModel from '@/common/models/entity-model';
import shortid from 'shortid';

export default class JobModel extends EntityModel {
    hydrate({
        id = null,
        location = null,
        type = null,
    } = {}) {
        this.id = id || shortid.generate();
        this.location = location;
        /**
         * @type {Moment}
         */
        this.type = type;
    }

    get isFrontend() {
        return this.location === JobModel.Locations.frontend;
    }

    get isBackend() {
        return this.location === JobModel.Locations.backend;
    }

    static Statuses = {
        pending: 'pending',
        running: 'running',
        completed: 'completed',
    };

    static Types = {
        dataExport: 'data-export',
        batchRefund: 'batch-refund',
    };

    static Locations = {
        frontend: 'frontend',
        backend: 'backend',
    }

    getPayload() {
        return {
            id: this.id,
            location: this.location,
            processedOn: this.processedOn,
            type: this.type,
        };
    }
}
